<template>
    <div>
        <vs-popup title="" 
            :button-close-hidden="true" 
            :active.sync="isActive" 
            @close="$emit('isActiveFalse')"
            style="border-radius: 10px !important;"
            id="popUpNewCustomer"
        >
            <div>
                <span id="display-span-orders">
                    <vs-icon @click="isUpdate ? $emit('backToOrderSummaryFromNotes', [], '', false) : $emit('backToPayment')" class="mr-2" icon="keyboard_arrow_left" style="border: solid 1px; border-radius: 14px; cursor: pointer;"/>
                    <p class="ml-2" style="font-size: 16px; width: 450px;">Anexar Arquivos e Observações 
                        (<span style="color: #8c8c8c;">opcional</span>)</p>
                    <div class="flex-end-align">
                        <vs-icon @click="$emit('isActiveFalse')" class="mr-2" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right;"></vs-icon>
                    </div>
                </span>
            </div>

            <div id="upload-div">
                <upload
                    :action="uploadApiUrl"
                    fileName="file"
                    :headers="{
                        Authorization: 'Bearer ' + bearer
                    }"
                    ref="uploadComponent"
                    text="Anexar arquivos"
                    automatic
                    :limit="500"
                    :multiple="true"
                    :maxSize="10"
                    :single-upload="true"
                    @on-success="successUpload"
                    @on-error="errorUpload"
                    @on-upload-start="imageUploaded = false"
                    @on-delete="deleteUploadImage"
                />
            </div>

            <div>
                <ul class="con-s">
                    <li>
                        <label for="">Adicionar Observação</label>
                        <vs-switch v-model="noteSwitch"/>
                    </li>
                </ul>

                <vs-textarea v-if="noteSwitch" class="mt-2" v-model="note"/>
            </div>

            <div style="margin-bottom: 5em;">
                <vs-button @click="continueFlow" class="btn-drop px-3 mr-0 mt-2" type="filled" icon="keyboard_arrow_right" icon-after style="float: right !important; border-radius: 12px;">
                    {{ isUpdate ? 'Atualizar' : 'Próximo/Pular' }}
                </vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>

    import Upload from '@/components/upload/Upload'
    import orderApi from "@/http/requests/orders"

    export default {
        name: 'NotesAndFiles',
        data() {
            return {
                fileUrl: [],
                noteSwitch: false,
                note: '',
            }
        },
        components: {
            Upload
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            isUpdate: {
                type: Boolean,
                required: true
            },
            orderId: {
                type: Number,
                required: false
            },
        },
        computed: {
            uploadApiUrl() {
                return localStorage.getItem('baseUrl') + '/api/file/upload'
            },
            bearer() {
                return this.$store.state.auth.bearer
            },
        },
        methods: {
            errorUpload(request) {
                this.$vs.notify({
                color: 'danger',
                title: 'Erro ao anexar o arquivo',
                text: request.data.message
                })
            },
            successUpload(response) {
                const parsedResponse = JSON.stringify(response.data);
                if ( parsedResponse === JSON.stringify(this.fileUrl) ) { return; }

                this.fileUrl = JSON.parse(parsedResponse);
                this.$vs.notify({
                    color: 'success',
                    title: 'Arquivo anexado com sucesso',
                    text: response.data.message
                })
            },
            deleteUploadImage(args = null) {

                if (args && args.method === "number" ){
                    const itemIndex = this.fileUrl.findIndex((c) => c.name === args.file.name)
                    if ( itemIndex !== -1){
                        return this.fileUrl.splice(itemIndex, 1);
                    } 
                    else if ( this.fileUrl.length > 0 ){ return }

                } else if (args === null) {
                    this.$refs.uploadComponent.removeFile(null, true)
                }
                this.fileUrl = [];
            },
            continueFlow() {
                this.fileUrl.map((item, index) => {
                    const fileNameParts = item.name.split('.');
                    if (fileNameParts.length > 1) {
                        const fileExtension = fileNameParts[fileNameParts.length - 1];
                        this.fileUrl[index].documentMimetype = fileExtension;
                    }
                });

                if (this.isUpdate) {
                    let data = {
                        id: this.orderId,
                        note: this.noteSwitch ? this.note : null,
                        files: this.fileUrl ? JSON.stringify(this.fileUrl) : null
                    }

                    orderApi.update(data)
                    .then((response) => {
                        this.$emit('backToOrderSummaryFromNotes', this.fileUrl, this.noteSwitch ? this.note : '')
                        return this.$vs.notify({
                            color: 'success',
                            title: 'Sucesso!',
                            text: 'Atualização feita com sucesso!'
                        });
                    })
                    .catch((exception) => {
                        console.log(exception);
                        return this.$vs.notify({
                            color: 'danger',
                            title: 'Erro!',
                            text: 'Erro ao atualizar os dados, por favor nos contate para corrigir-mos!'
                        });
                    });
                } 
                else {
                    this.$emit('sendToPreOrdersSummary', this.fileUrl, this.noteSwitch ? this.note : '')
                }
            }
        },
        watch: {
            isActive(val) {
                if (val) {
                    this.note = '';
                    this.fileUrl = [];
                    this.noteSwitch = false;
                    this.deleteUploadImage();
                }
            }
        }
    }
</script>

<style lang="scss">
    #popUpNewCustomer div.vs-popup {
        .vs-popup--content {
        padding: 15px;
        margin: 0;
        }
        margin: 0;
        border-radius: 18px !important;
        border: solid 1.2px;
        border-color: rgba(18, 17, 17, 0.769);
        width: 700px;
        .vs-popup--header {
            background-color: transparent !important;
            .vs-popup--title {
                background-color: transparent !important;
                h3 {
                    background-color: transparent !important;
                }
            }
        }
        header {
            background-color: transparent !important;
        }
        input.vs-inputx.vs-input--input.normal {
            border-radius: 14px !important;
            width: 300px;
        }
    }
    #upload-div .con-input-upload {
        margin-left: 30% !important;
    }
</style>